import "../scss/customer.scss";
import { initFormUpdateCustomer, toggleLoginForm } from "../components/login";
import { togglePassword } from '../utils/input-password';
import { initAddress } from "../components/customerAddress";

toggleLoginForm();

togglePassword();

initAddress();

initFormUpdateCustomer();
